/**
 * The Otto embed-script origin used in a bot's `<script src=…>` snippet.
 * Reads the `OTTO_BASE_URL` runtime global (set per-deploy), defaulting to the
 * production support host, and strips a trailing slash so the snippet's
 * `${origin}/embed.js` never doubles up. Extracted from `BotsPanel.tsx` so the
 * default + trim logic unit-tests directly.
 */
export function otSrcOrigin(): string {
  return ((globalThis as { OTTO_BASE_URL?: string }).OTTO_BASE_URL ?? "https://support.xopnetworks.com/otto").replace(/\/$/, "");
}
